import React, { createContext, useContext, useEffect, useState } from "react";
import { authMe, authLogin, authRegister, authGoogleCode, authLogout, getUserToken, toggleFavorite as apiToggleFav, verifyLoginCode, confirmPasswordReset } from "@/lib/api";
import { setProjectsOwner, syncProjects } from "@/lib/projects";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getUserToken()) { setLoading(false); return; }
    authMe().then(setUser).catch(() => authLogout()).finally(() => setLoading(false));
  }, []);

  // I design salvati hanno una cache locale per utente: appena sappiamo chi è
  // collegato la agganciamo al suo account e migriamo quelli lasciati nel
  // browser prima dell'accesso.
  useEffect(() => {
    setProjectsOwner(user?.user_id || null);
    if (user?.user_id) syncProjects(user.user_id).catch(() => {});
  }, [user?.user_id]);

  const login = async (email, password) => { const d = await authLogin({ email, password }); setUser(d.user); return d; };
  const register = async (payload) => { const d = await authRegister(payload); setUser(d.user); return d; };
  const loginGoogleCode = async (code, redirectUri) => { const d = await authGoogleCode(code, redirectUri); setUser(d.user); return d; };
  const loginWithCode = async (email, code) => { const d = await verifyLoginCode(email, code); setUser(d.user); return d; };
  const resetPassword = async (token, password) => { const d = await confirmPasswordReset(token, password); setUser(d.user); return d; };
  const logout = () => { authLogout(); setUser(null); };
  const refreshUser = async () => { try { const u = await authMe(); setUser(u); return u; } catch { return null; } };

  const isFav = (slug) => !!user?.favorites?.includes(slug);
  const toggleFav = async (slug) => {
    if (!user) return { needAuth: true };
    const res = await apiToggleFav(slug);
    setUser((u) => (u ? { ...u, favorites: res.favorites } : u));
    return { active: res.active };
  };

  return (
    <AuthContext.Provider value={{ user, loading, isReady: !loading, login, register, loginGoogleCode, loginWithCode, resetPassword, logout, setUser, refreshUser, isFav, toggleFav }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
